<template>
    <div class="ads-video-box">
        <div class="video-part">
            <AdvDisplayComponent
                :record="record"
                v-if="videoVisible"
            />
        </div>

        <div
            class="arrow-icon-btn left-arrow-icon"
            v-show="leftIconVisible"
            @click="clickLeftBtn"
        >
            <font-awesome-icon icon="fa-solid fa-chevron-left" beat-fade />
        </div>

        <div
            class="arrow-icon-btn right-arrow-icon"
            v-show="rightIconVisible"
            @click="clickRightBtn"
        >
            <font-awesome-icon icon="fa-solid fa-chevron-right" beat-fade />
        </div>
    </div>
</template>

<script setup>

import {ref, onBeforeMount, computed} from "vue";
import AdvDisplayComponent from "@/components/shopopee/promotion/advDisplayComponent.vue";
import jobArrangementRecordApi from "@/request/jobArrangementRecordApi";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

library.add(faChevronLeft, faChevronRight)

const props = defineProps(["data"])

const record = ref(null)

let advList = ref([])
let advIndex = ref(0)
let videoVisible = ref(true)

const leftIconVisible = computed(() => {
    return advIndex.value > 0
})

const rightIconVisible = computed(() => {
    return advIndex.value < advList.value.length - 1
})

function queryCompanyAdsRecord(){
    const request = jobArrangementRecordApi.queryRecord
    const params = request.getParams()

    params.companycode = props.data.companycode
    params.jatype = '-99'

    request.send(params, (res) => {
        if (res.code == 200){
            generateAdsList(res.detail)
        }
    })
}

function generateAdsList(list){
    if (null == list || list.length == 0){
        return
    }

    const dataList = []

    list.forEach((v, i) => {
        if (v.id == props.data.advId){
            return
        }

        const obj = {
            companycode: v.companycode,
            advID: v.id,
            advTitle: v.jobtitle,
            advDes: v.addinfo1,
            advImg: v.addinfo5,
            advUrl: v.addinfo2,
            advVideoPath: v.addinfo3,
            fbUrl: v.ordertorefno,
            redUrl: v.orderrefno,
            titokUrl: v.orderref,
            ytbUrl: v.orderreplyremark,
        }

        dataList.push(obj)
    })

    advList.value = advList.value.concat(dataList)

}

function clickLeftBtn(){
    advIndex.value -= 1

    if (advIndex.value < 0){
        advIndex.value = 0
    }

    videoVisible.value = false
    record.value = advList.value[advIndex.value]

    setTimeout(() => {
        videoVisible.value = true
    }, 100)
}

function clickRightBtn(){
    advIndex.value += 1

    if (advIndex.value >= advList.value.length){
        advIndex.value = advList.value.length - 1
    }

    videoVisible.value = false
    record.value = advList.value[advIndex.value]

    setTimeout(() => {
        videoVisible.value = true
    }, 100)
}

onBeforeMount(() => {
    advList.value.push(props.data)
    record.value = props.data

    queryCompanyAdsRecord()
})

</script>

<style scoped>

.ads-video-box {
    width: 100%;
    position: relative;
}

@media screen and (min-width: 768px) {
    .video-part {
        width: calc(100% - 40px);
        margin: auto;
    }

    .arrow-icon-btn {
        position: absolute;
        font-size: 32px;
        text-align: center;
        cursor: pointer;
    }

    .left-arrow-icon {
        top: calc(50% - 24px);
        left: 0;
    }

    .right-arrow-icon {
        top: calc(50% - 24px);
        right: 0;
    }
}

@media screen and (max-width: 768px) {
    .video-part {
        width: 100%;
    }

    .arrow-icon-btn {
        position: absolute;
        font-size: 32px;
        text-align: center;
        cursor: pointer;
    }

    .left-arrow-icon {
        top: calc(100% - 32px);
        left: 0;
    }

    .right-arrow-icon {
        top: calc(100% - 32px);
        right: 0;
    }
}

</style>